import {Delete, Get, Post, Put} from "./config";

// Bank Endpoint
export const storeBank = (params) => Post('banks', params);
export const updateBank = (id, params) => Put('banks', id, params);
export const fetchBanks = (params) => Get( 'banks', params);
export const fetchBankById = (id) => Get( 'banks/' + id);
export const deleteBankById = (id, params) => Delete( 'banks/' + id, params);
